export const OTHERS_RSD_LABEL = {
  RentType: 'Rent Type',
  LeaseTerm: 'Lease Term',
  Summary: 'Summary',
  AddLeaseTerm: '+ Add Lease Term',
  FixedRent: 'Fixed Rent',
  FixedRentLongForm: 'Rent is Fixed for the Entire Lease Term',
  VaryingRent: 'Varying Rent',
  VaryingRentLongForm: 'Rent Varies During the Lease Term',
  TotalRentPerMonth: 'Total Rent per Month',
  ExcludesGST: 'Excludes GST',
  TotalRentPerMonthNote:
    'Note: Total rent per month include rent for premises, furnitures and fittings, service and maintenance, and other charges.',
  StartDate: 'Start Date',
  EndDate: 'End Date',
  IsPremiumConsiderationMadeForThisLease: 'Is Premium/Consideration Made for This Lease?',
  IsPremiumTooltipContent: 'Any lump sum payment (excluding security deposit) made for this lease.',
  TypeOfProperty: 'Type of Property',
  PremiumConsiderationForResidentialComponent: 'Premium/Consideration for Residential Component',
  PremiumConsiderationForNonResidentialComponent:
    'Premium/Consideration for Non-Residential Component',
  RentalStampDutyAmount: 'Rental Stamp Duty Amount',
  Calculate: 'Calculate',
  GotIt: 'Got it',
  IrasNote1:
    'Our rental stamp duty calculator is temporarily unavailable due to IRAS API service disruption.',
  IrasNote2: 'You can still proceed using',
};

export const IRAS_API_INFO = {
  Link: 'https://apiservices.iras.gov.sg/iras/devportal/product',
  Text: 'IRAS API Services',
};

export const IRAS_TERMS_CONDITION_INFO = {
  Link: 'https://apiservices.iras.gov.sg/iras/devportal/pages/terms-use',
  Text: 'Terms & Conditions of Use of IRAS API Marketplace website.',
};

export const IRAS_OFFICIAL_SITE_INFO = {
  Link: 'https://mytax.iras.gov.sg/ESVWeb/default.aspx?target=MSDCalculatorIntro',
  Text: 'the official IRAS calculator.',
};

export enum RentType {
  FIXED_RENT = 'Fixed Rent',
  VARYING_RENT = 'Varying Rent',
}

export const getRentTypeText = (type: string, isMobile: boolean) => {
  switch (type) {
    case RentType.FIXED_RENT: {
      return isMobile ? OTHERS_RSD_LABEL.FixedRent : OTHERS_RSD_LABEL.FixedRentLongForm;
    }

    case RentType.VARYING_RENT: {
      return isMobile ? OTHERS_RSD_LABEL.VaryingRent : OTHERS_RSD_LABEL.VaryingRentLongForm;
    }

    default: {
      return '';
    }
  }
};

export enum IsPremium {
  YES = 'Yes',
  NO = 'No',
}

export enum TypeOfProperty {
  RESIDENTIAL = 'Fully Residential',
  MIXED = 'Mixed (with residential component)',
  NON_RESIDENTIAL = 'Non-Residential',
}

export const getTypeOfProperty = (type: string) => {
  switch (type) {
    case TypeOfProperty.MIXED: {
      return 'Mixed';
    }

    case TypeOfProperty.RESIDENTIAL: {
      return 'Residential';
    }

    case TypeOfProperty.NON_RESIDENTIAL: {
      return 'Non-Residential';
    }

    default: {
      return '';
    }
  }
};
